<div class="full-content" *ngIf="expandableText">
  <h5 class="h5">{{expandableText.title}}</h5>
  <div *ngIf="shouldShowReadMore" [innerHtml]="expandableText.previewText | floSanitizeHtml" floDynamicContent></div>
  <div *ngIf="!shouldShowReadMore" [innerHtml]="expandableText.fullText | floSanitizeHtml" floDynamicContent></div>
  <a *ngIf="!!expandableText.fullText && expandableText.shouldShowReadMore" class="primary-color-text subhead" (click)="toggleExpand()">{{ expandText }}</a>
</div>